import { getColor } from '../../theme-tools';
import { asMultiStyleConfig } from '../../utils/theme';
import { getDefaults } from './input';
var parts = ['container', 'control', 'label', 'icon'];
var checkedControlStyles = {
  bg: 'blue.600',
  color: 'white',
  _focus: {
    borderColor: '#00CAFF'
  },
  _disabled: {
    bg: 'grey.500'
  },
  _invalid: {
    bg: 'red.700'
  }
};
function baseStyleControl(props) {
  var {
    theme
  } = props;
  var {
    focusBorderColor,
    errorBorderColor,
    focusBoxShadowColor,
    errorBoxShadowColor
  } = getDefaults(props);
  return {
    w: '100%',
    border: '1.5px solid',
    borderRadius: 'sm',
    borderColor: 'blue.600',
    color: 'white',
    transition: 'all .15s',
    _checked: checkedControlStyles,
    _indeterminate: checkedControlStyles,
    _disabled: {
      borderColor: 'grey.500'
    },
    _focus: {
      borderColor: focusBorderColor,
      boxShadow: "0 0 3px 2px ".concat(getColor(theme, focusBoxShadowColor))
    },
    _invalid: {
      borderColor: errorBorderColor,
      boxShadow: "0 0 4px 1px ".concat(getColor(theme, errorBoxShadowColor))
    }
  };
}
var baseStyleLabel = {
  userSelect: 'none',
  mb: 0,
  _disabled: {
    opacity: 0.4
  }
};
var baseStyle = props => ({
  control: baseStyleControl(props),
  label: baseStyleLabel
});
var sizes = {
  md: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: '0.8rem'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  defaultProps
});